var render = function render(_c,_vm){return _c('span',{staticClass:"rounded text-white",class:[_vm.props.small ? 'font-size-60 font-weight-500' : 'font-size-80 font-weight-600', 'bg-' + _vm.props.variant, 'mx-' + _vm.props.xMargin],staticStyle:{"padding":"2px 4px"}},[_vm._v(_vm._s(_vm.props.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }